import { LocalizedStringsMethods } from './types/string-types'
import { planPrice, pricing } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'

export type LocalizedStrings = LocalizedStringsMethods

type StringsSingleton = {
  instance: LocalizedStrings | undefined
}

const strings: StringsSingleton = {
  instance: undefined,
}

const getStrings: () => LocalizedStrings = () => {
  if (!strings.instance) {
    throw new Error(
      'Strings is not initialized. Make sure Web or Mobile sets strings.instance',
    )
  }
  return strings.instance
}
export type LanguageContent = typeof defaultContent

const setStrings = (stringsParam: LocalizedStrings) => {
  strings.instance = stringsParam
}

export function blobbyStrings(strings: Record<string, string>) {
  // @ts-ignore
  const blobby: LanguageContent = {}
  Object.keys(strings).map((key) => {
    // @ts-ignore
    const val = strings[key]
    const words = val.split(' ')
    const newWordsBlobby = words.map((word: string, index: number) => {
      const arr = ['eeeee', 'blob', 'blobby', 'wuueeeeh']
      const idx = Math.floor(Math.random() * arr.length)
      if (word.indexOf('{') !== -1) {
        // reserve params
        return word
      }
      return arr[idx]
    })
    blobby[key as keyof LanguageContent] = `${newWordsBlobby.join(' ').trim()}`
  })
  return blobby
}

const defaultContent = {
  aboutUs: 'About Us',
  add: 'Add',
  addons: 'Add-ons',
  address: 'Address',
  australia: 'Australia',
  becomeAPartner: 'Become a partner',
  blog: 'Blog',
  businessSupport: 'Business Support',
  businessType: 'Business type',
  characterRemaining: '{0} character remaining',
  charactersRemaining: '{0} characters remaining',
  checkOutOurOtherCommunityPages: 'Check out our other community pages',
  checkout: 'Checkout',
  clickHere: 'Click here',
  company: 'Company',
  companyFormation: 'Company Formation',
  companyInformation: 'Need Help?',
  companyNo: 'Company no.',
  companyNumber: 'Company number',
  companyNumberPlaceholder: 'Type Company number here',
  contactInformation: 'Contact information',
  contactUs: 'Contact Us',
  copyright:
    'Copyright © 2010 - {0} {name} <strong>The Hoxton Mix Limited</strong>. All rights reserved.',
  copyrightAu:
    'Copyright © 2010 - {0} {name} <strong>The Hoxton Mix Australia Pty Ltd</strong>. All rights reserved.',
  countryOfIncorporation: 'Country of incorporation',
  customerCare: 'Customer Care',
  directions: 'Directions',
  download: 'Download the full',
  downloadTime: 'File size: {0} KB — typically downloads in 1–2 seconds.',
  emailAddress: 'Email Address',
  enquireNow: 'Enquire now',
  enterpriseSystems: 'Partner Network',
  enterpriseSystemsSubHeading: 'Deliver address services at scale',
  faq: 'FAQ',
  faqDescription:
    'A cheap virtual business address to impress without the costs',
  firstName: 'First Name',
  followUs: 'Follow Us',
  freeAccountingService: 'Free Accounting Service',
  freeBusinessBanking: 'Free Business Banking',
  frequentlyAskedQuestions: 'Frequently asked questions',
  getAPrimeBusinessAddress:
    'Get a Prime London business address <br/> 10 Minute Setup + <strong>NO Postage Fees!</strong>',
  gettingYouSetup:
    '<span class="d-sm-inline d-block">Getting you set up</span> is easy as',
  helpAndAdvice: 'Help & Advice',
  heroTitle:
    '<span class="d-sm-block">Want an impressive<span/> <span class="d-sm-block">London business address?</span>',
  home: 'Home',
  hoxtonMixApp: 'Mobile Apps',
  icoNumber: 'ICO no.',
  keepUpToDate: 'Keep up to date with what’s going on in the mix…',
  konnect: 'Konnect',
  kycRequirements: 'KYC Requirements',
  lastName: 'Last Name',
  legalInformation: 'Legal Information',
  legalName: 'Legal name',
  legalNamePlaceholder: 'Type legal name here',
  letUsHelp: 'Let us help you get started on your business journey.',
  login: 'Login',
  logo: 'Logo',
  londonsTechnologyHub: 'London’s technology hub',
  mailroom: 'Mailroom',
  marketPlace: 'Marketplace',
  membership: 'Membership',
  mlrNumber: 'MLR no.',
  needHelp: 'Need Help?',
  newsAndEventsBlog: 'News & Events Blog.',
  next: 'Next',
  notACustomer: 'Not a Virtual Office customer? Why not sign-up today.',
  offers: 'Offers',
  openingHours: 'Opening hours',
  openingHoursDescription: 'Monday – Friday, 9 a.m. – 6 p.m.',
  openingHoursDescriptionAu: 'Monday – Friday, 9 am – 6 pm AEST',
  ourAddress: 'Our Address',
  ourOfficeIsLocated:
    'Our Paul Street office is just a few minutes walk<br class="d-lg-block d-none"/> from Old Street tube station…',
  outreach: 'Outreach',
  page: 'Page',
  paulStreet: 'Paul Street',
  payment: 'Payment',
  perDay: 'Per day',
  perMonth: 'Per Month',
  perYear: 'Per Year',
  phone: 'Phone',
  pleaseSelect: 'Select an Option...',
  plusVAT: '+ VAT',
  previous: 'Previous',
  privacy: 'Privacy',
  privacyPolicy: 'Privacy Centre',
  privateOffices: 'Private Offices',
  products: 'Products',
  region: 'Region',
  remove: 'Remove',
  search: 'Search',
  serviceIncludes: 'Our service includes:',
  services: 'Services',
  showAll: 'Show All',
  showMore: 'Show more',
  signupIncludes: 'Our sign-up includes:',
  siliconRoundabout: 'Silicon Roundabout',
  socialImpact: 'Social Impact',
  support: 'Support',
  termsAndConditions: 'Terms & Conditions',
  toggleNav: 'Toggle navigation',
  tradingName: 'Trading name',
  tradingNamePlaceholder: 'Type Trading name here',
  unitedKingdom: 'United Kingdom',
  uptimeAndStatus: 'Uptime and Status',
  viewPlans: 'View Plans',
  virtualOffice: 'Virtual Office',
  virtualOfficeLondon: 'Virtual Office London',
  virtualOfficePhone: 'WhatsApp Business Number',
  virtualOfficePlans: 'Virtual Office Plans',
  virtualOfficeProducts: 'Virtual Office',
  virtualOfficeScanLite: 'Virtual Office London',
  virtualOfficeScanLiteLink: 'Virtual Office London',
  virtualOfficeScanPro: 'Virtual Office HaiRo™ + Forward',
  virtualOfficeScanProLink: 'Mail Forwarding Services',
  weHaveHelped: 'We’ve already supported thousands of companies.',
  whatDoesYourCompanyDo: 'What does your company do?',
  whatDoesYourCompanyDoPlaceholder:
    'e.g. "We provide IT support services to small UK retail businesses."',
  whatDoesYourCompanyDoSubtitle:
    'Just 1\u20132 sentences is enough (e.g. what you provide and who for).',
  whereShallWeSendThePost: 'Where shall we send the post?',
}
const stringRecords: Record<string, Partial<LanguageContent>> = {
  en: defaultContent,
  es: blobbyStrings(defaultContent),
}
export { stringRecords, getStrings, setStrings }
